import React, { useCallback, useState } from 'react'
import { IconButton, makeStyles } from '@material-ui/core'
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined'
import { primaryBlue } from '../../styles/material-ui-theme-v2'

const useStyles = makeStyles({
  '@keyframes checkPop': {
    '0%': { transform: 'scale(0) rotate(-45deg)', opacity: 0 },
    '60%': { transform: 'scale(1.2) rotate(0deg)', opacity: 1 },
    '100%': { transform: 'scale(1) rotate(0deg)', opacity: 1 },
  },
  '@keyframes fadeIn': {
    '0%': { opacity: 0, transform: 'scale(0.8)' },
    '100%': { opacity: 1, transform: 'scale(1)' },
  },
  button: {
    transition: 'transform 0.2s ease',
    '&:active': { transform: 'scale(0.95)' },
  },
  copyIcon: {
    animation: '$fadeIn 0.2s ease',
  },
  checkIcon: {
    animation: '$checkPop 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards',
    color: primaryBlue,
  },
})

interface YumCopyButtonProps {
  text: string
  size?: number
  duration?: number
}

export default function YumCopyButton({ text, size = 16, duration = 1500 }: YumCopyButtonProps) {
  const classes = useStyles()
  const [copied, setCopied] = useState(false)

  const handleClick = useCallback(() => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), duration)
  }, [text, duration])

  return (
    <IconButton size="small" onClick={handleClick} className={classes.button}>
      {copied ? (
        <svg
          className={classes.checkIcon}
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15.188 5.11a.5.5 0 0 1 .752.626l-.056.084-7.5 9a.5.5 0 0 1-.738.033l-3.5-3.5-.064-.078a.501.501 0 0 1 .693-.693l.078.064 3.113 3.113 7.15-8.58z" />
        </svg>
      ) : (
        <FileCopyOutlined className={classes.copyIcon} style={{ fontSize: size }} />
      )}
    </IconButton>
  )
}
